export default "__VITE_ASSET__eANn0JNk__"